import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2d46beb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {
          overflow: 'hidden',
        } }
const _hoisted_2 = ["alt", "src"]

import { IconShareInternal } from "@arco-design/web-vue/es/icon";
import API from "@/api";
import { ref } from "vue";
import { useRouter } from "vue-router";
import ShareModal from "@/components/ShareModal.vue";
import {
  getAppColor,
  REVIEW_STATUS_ENUM,
  REVIEW_STATUS_MAP,
} from "@/constant/app";

interface Props {
  app: API.AppVO;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyAppCard',
  props: {
    app: { default: () => {
    return {};
  } }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

const doCardClick = () => {
  router.push(`/app/detail/${props.app.id}`);
};

const shareModalRef = ref();

const shareLink = `${window.location.protocol}//${window.location.host}/app/detail/${props.app.id}`;

const doShare = (e: Event) => {
  if (shareModalRef.value) {
    shareModalRef.value.openModal();
  }
  // 阻止事件冒泡
  e.stopPropagation();
};

return (_ctx: any,_cache: any) => {
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      class: "appCard",
      hoverable: "",
      onClick: doCardClick
    }, _createSlots({
      actions: _withCtx(() => [
        _createElementVNode("span", null, [
          _createVNode(_component_a_tag, {
            color: _unref(getAppColor)(_ctx.app.reviewStatus as number)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(REVIEW_STATUS_MAP)[_ctx.app.reviewStatus]), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        (_ctx.app.reviewStatus === _unref(REVIEW_STATUS_ENUM).PASS)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "icon-hover",
              onClick: doShare
            }, [
              _createVNode(_unref(IconShareInternal))
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_card_meta, {
          title: _ctx.app.appName
        }, null, 8, ["title"])
      ]),
      _: 2
    }, [
      (_ctx.app.appIcon)
        ? {
            name: "cover",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                  style: { width: '100%', transform: 'translateY(-20px)' },
                  alt: _ctx.app.appName,
                  src: _ctx.app.appIcon
                }, null, 8, _hoisted_2)
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    _createVNode(ShareModal, {
      link: shareLink,
      title: "应用分享",
      ref_key: "shareModalRef",
      ref: shareModalRef
    }, null, 512)
  ], 64))
}
}

})